import { MenuItem } from '../models/menu-item';

export const MENUITEMS: MenuItem[] =
[
    {
        id: 2,
        routerLink: 'about',
        nameEN: 'About us',
        nameIT: 'Chi siamo',
        guard: false
    },
    {
        id: 3,
        routerLink: 'fleet',
        nameEN: 'Fleet',
        nameIT: 'Flotta',
        guard: false
    },
    {
        id: 4,
        routerLink: 'crew',
        nameEN: 'Crew',
        nameIT: 'Equipaggio',
        guard: false
    },
    {
        id: 5,
        routerLink: 'reservation',
        nameEN: 'Reservation',
        nameIT: 'Prenotazioni',
        guard: false
    },
    {
        id: 6,
        routerLink: 'fly-conditions',
        nameEN: 'Fly Conditions',
        nameIT: 'Condizioni di volo',
        guard: false
    },
    {
        id: 7,
        routerLink: 'privacy',
        nameEN: 'Privacy',
        nameIT: 'Privacy',
        guard: false
    },

];
